export default __webpack_public_path__ + "static/media/howItWorksHire5.f20e6c96.png";